// src/pages/WelcomeLetter.jsx
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import stampImg from "../assets/2.png";
import signatureImg from "../assets/Since 2026.png";

const PRIMARY_GREEN = "#76b82a";
const LIGHT_GREEN = "#f4f9eb";
const BLUE_TEXT = "#00aeef";
const DARK_TEXT = "#1a1a1a";
const GRAY_TEXT = "#555555";

export default function WelcomeLetter() {
    const navigate = useNavigate();
    const printRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState("");
    const [data, setData] = useState(null);
    const [lang, setLang] = useState("en"); // 'en' or 'te'

    const token = localStorage.getItem("token") || localStorage.getItem("authToken") || "";

    useEffect(() => {
        if (!token) { navigate("/login", { replace: true }); return; }
        fetchLetter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchLetter = async () => {
        try {
            setLoading(true);
            setErr("");
            const res = await axiosInstance.get("/api/auth/welcome-letter");
            setData(res?.data || null);
        } catch (e) {
            setErr(
                e?.response?.data?.msg ||
                e?.response?.data?.message ||
                e?.message ||
                "Failed to load welcome letter"
            );
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = () => { window.print(); };

    const safe = (v, fb = "N/A") => {
        if (v === null || v === undefined || String(v).trim() === "") return fb;
        return String(v).trim();
    };

    const content = {
        en: {
            title: "SUN DISTRIBUTORS",
            welcome: "Welcome Letter",
            dear: "Dear",
            congrats: "Congratulations and a warm welcome to the SUN DISTRIBUTORS family!",
            memberId: "Member ID",
            decisionText: "Your decision to grow in life, become financially strong, and achieve self-employment is truly commendable. Thank you for joining our organization with such a positive vision.",
            aboutTitle: "About SUN DISTRIBUTORS",
            aboutDesc: "SUN DISTRIBUTORS is an Entrepreneurs Manufacturing Company dedicated to transforming ordinary individuals into successful entrepreneurs.",
            learnTitle: "Through our platform, you will learn:",
            learnItems: [
                "How to start a business",
                "How to sell products effectively",
                "How to communicate with customers",
                "How to grow your business using digital platforms"
            ],
            trainingTitle: "Training & Support",
            trainingItems: [
                "90 Days Free Training Program",
                "Daily 30 Minutes Online Video Sessions",
                "Daily Practice Guidance",
                "Senior Mentor Support",
                "Complete Training on 8 Product Categories"
            ],
            successTitle: "Your Success Journey",
            successGoal: "Our goal is to help you:",
            successItems: [
                "Learn business completely",
                "Practice daily",
                "Earn a good income",
                "Improve your family’s standard of living",
                "Achieve all your financial goals"
            ],
            beliefTitle: "Our Belief",
            beliefDesc: "With discipline and dedication, you can achieve success and earn ₹50,000 to ₹1,00,000 or more per month.",
            supportLine: "SUN DISTRIBUTORS will support you at every step of your journey.",
            successWish: "Your success is our success. We wish you a bright and successful future.",
            thankYou: "Thank you,",
            team: "SUN DISTRIBUTORS Team",
            quote: "“Change Your Thought – Change Your Life”"
        },
        te: {
            title: "SUN DISTRIBUTORS",
            welcome: "స్వాగత పత్రం (Welcome Letter)",
            dear: "ప్రియమైన",
            congrats: "మీరు SUN DISTRIBUTORS కుటుంబంలో సభ్యుడిగా చేరినందుకు హృదయపూర్వక స్వాగతం మరియు అభినందనలు.",
            memberId: "Member ID",
            decisionText: "మీరు జీవితంలో ఎదగాలని, ఆర్థికంగా బలపడాలని, స్వయం ఉపాధి సాధించాలని తీసుకున్న ఈ నిర్ణయం ఎంతో గొప్పది. ఈ మంచి సంకల్పంతో మా సంస్థలో చేరినందుకు మీకు ధన్యవాదాలు.",
            aboutTitle: "SUN DISTRIBUTORS గురించి",
            aboutDesc: "SUN DISTRIBUTORS ఒక Entrepreneurs Manufacturing Company, ఇది సాధారణ వ్యక్తులను విజయవంతమైన వ్యాపారవేత్తలుగా తీర్చిదిద్దడం లక్ష్యంగా పని చేస్తుంది.",
            learnTitle: "మా సంస్థ ద్వారా మీరు:",
            learnItems: [
                "వ్యాపారం ఎలా ప్రారంభించాలి",
                "ప్రొడక్ట్స్ ఎలా అమ్మాలి",
                "కస్టమర్లతో ఎలా మాట్లాడాలి",
                "డిజిటల్ ప్లాట్ఫార్మ్స్ ద్వారా ఎలా వ్యాపారం పెంచాలి"
            ],
            trainingTitle: "Training & Support",
            trainingItems: [
                "90 రోజుల ఫ్రీ ట్రైనింగ్ ప్రోగ్రామ్",
                "ప్రతిరోజూ 30 నిమిషాల ఆన్లైన్ వీడియోలు",
                "డైలీ ప్రాక్టీస్ గైడెన్స్",
                "సీనియర్ మెంటర్ సపోర్ట్",
                "8 కేటగిరీస్ ప్రొడక్ట్స్పై పూర్తి శిక్షణ"
            ],
            successTitle: "మీ విజయ ప్రయాణం",
            successGoal: "మా కోరిక ఏమిటంటే:",
            successItems: [
                "మీరు వ్యాపారాన్ని పూర్తిగా నేర్చుకోవాలి",
                "ప్రతిరోజూ ప్రాక్టీస్ చేయాలి",
                "మంచి ఆదాయం సంపాదించాలి",
                "మీ కుటుంబాన్ని ఉన్నత స్థాయికి తీసుకెళ్లాలి",
                "మీ Financial Goals అన్నింటినీ పూర్తి చేసుకోవాలి"
            ],
            beliefTitle: "మా నమ్మకం",
            beliefDesc: "మీరు క్రమశిక్షణతో, పట్టుదలతో ముందుకు సాగితే —మీరు నెలకు ₹50,000 నుండి ₹1,00,000 లేదా అంతకంటే ఎక్కువ సంపాదించే స్థాయికి చేరవచ్చు.",
            supportLine: "SUN DISTRIBUTORS మీ ప్రతి అడుగులో మీతో పాటు ఉంటుంది.",
            successWish: "మీ విజయమే మా విజయం. మీ భవిష్యత్తు విజయవంతంగా ఉండాలని కోరుకుంటున్నాము.",
            thankYou: "ధన్యవాదాలు,",
            team: "SUN DISTRIBUTORS Team",
            quote: "“మీ ఆలోచన మార్చండి – మీ జీవితాన్ని మార్చుకోండి”"
        }
    };

    const t = content[lang];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Montserrat:wght@900&family=Ramabhadra&display=swap');

                *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

                .wl-container {
                    min-height: 100vh;
                    background: #f0f2f5;
                    font-family: 'Inter', sans-serif;
                    padding-bottom: 50px;
                }

                /* ── TOP ACTION BAR ── */
                .wl-bar {
                    position: sticky; top: 0; z-index: 100;
                    background: #fff;
                    border-bottom: 1px solid #e0e0e0;
                    padding: 12px 24px;
                    display: flex; align-items: center; justify-content: space-between;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
                }
                .wl-bar-left { display: flex; gap: 12px; }
                .wl-back {
                    height: 40px; padding: 0 16px;
                    border-radius: 8px;
                    border: 1px solid #ddd;
                    background: #fff;
                    color: #333;
                    font-weight: 600;
                    cursor: pointer;
                    display: flex; align-items: center; gap: 8px;
                    transition: all 0.2s;
                }
                .wl-back:hover { background: #f8f8f8; border-color: #bbb; }
                
                .wl-lang-btn {
                    height: 40px; padding: 0 16px;
                    border-radius: 8px;
                    border: 1px solid ${BLUE_TEXT};
                    background: ${lang === 'te' ? BLUE_TEXT : '#fff'};
                    color: ${lang === 'te' ? '#fff' : BLUE_TEXT};
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s;
                    display: flex; align-items: center; gap: 6px;
                }

                .wl-print {
                    height: 40px; padding: 0 20px;
                    border-radius: 8px;
                    border: none;
                    background: ${PRIMARY_GREEN};
                    color: #fff;
                    font-weight: 700;
                    cursor: pointer;
                    display: flex; align-items: center; gap: 8px;
                    transition: transform 0.1s, opacity 0.2s;
                }
                .wl-print:hover { opacity: 0.9; transform: translateY(-1px); }

                /* ── LOADING & ERROR ── */
                .wl-status-box {
                    display: flex; flex-direction: column;
                    align-items: center; justify-content: center;
                    min-height: 70vh; gap: 20px;
                }
                .wl-spinner {
                    width: 40px; height: 40px;
                    border: 3px solid rgba(118, 184, 42, 0.2);
                    border-top-color: ${PRIMARY_GREEN};
                    border-radius: 50%;
                    animation: wl-spin 0.8s linear infinite;
                }
                @keyframes wl-spin { to { transform: rotate(360deg); } }

                /* ── PAPER (A4 FEEL) ── */
                .wl-paper-wrap {
                    max-width: 850px;
                    margin: 40px auto;
                    perspective: 1000px;
                    transition: all 0.3s ease;
                }
                .wl-paper {
                    background: #fff;
                    width: 100%;
                    min-height: 1122px; 
                    position: relative;
                    box-shadow: 0 15px 50px rgba(0,0,0,0.15);
                    padding: 60px 70px;
                    display: flex;
                    flex-direction: column;
                    color: ${DARK_TEXT};
                    overflow: hidden;
                    ${lang === 'te' ? "font-family: 'Ramabhadra', 'Inter', sans-serif;" : "font-family: 'Inter', sans-serif;"}
                }

                /* ── DECORATIONS ── */
                .wl-corner-top {
                    position: absolute; top: 0; right: 0;
                    width: 300px; height: 300px;
                    background: radial-gradient(circle at top right, ${PRIMARY_GREEN}22, transparent 70%);
                    z-index: 1;
                }
                .wl-side-strip {
                    position: absolute; left: 0; top: 0; bottom: 0;
                    width: 8px; background: ${PRIMARY_GREEN};
                    z-index: 5;
                }

                /* ── HEADER ── */
                .wl-header {
                    display: flex; justify-content: space-between; align-items: flex-start;
                    margin-bottom: 50px; position: relative; z-index: 10;
                    border-bottom: 2px solid ${LIGHT_GREEN};
                    padding-bottom: 20px;
                }
                .wl-brand-box h1 {
                    font-family: 'Montserrat', sans-serif;
                    font-size: 32px; font-weight: 900;
                    color: ${PRIMARY_GREEN}; line-height: 1; letter-spacing: -0.5px;
                }
                .wl-brand-box p {
                    font-size: 14px; font-weight: 600; color: ${GRAY_TEXT}; margin-top: 5px;
                }
                .wl-date-box { font-weight: 700; color: ${GRAY_TEXT}; font-size: 14px; }

                /* ── CONTENT ── */
                .wl-content { position: relative; z-index: 10; }
                
                .wl-salutation { font-size: 18px; font-weight: 800; margin-bottom: 10px; color: ${DARK_TEXT}; }
                .wl-recipient { font-size: 18px; font-weight: 700; color: ${BLUE_TEXT}; margin-bottom: 5px; }
                .wl-member-id { font-size: 15px; font-weight: 700; background: ${LIGHT_GREEN}; display: inline-block; padding: 4px 12px; border-radius: 4px; margin-bottom: 25px; }

                .wl-intro { font-size: 15px; line-height: 1.6; color: ${DARK_TEXT}; margin-bottom: 30px; font-weight: 500; }

                .wl-section { margin-bottom: 30px; }
                .wl-section-title { 
                    font-size: 18px; font-weight: 800; color: ${PRIMARY_GREEN}; 
                    margin-bottom: 15px; display: flex; align-items: center; gap: 10px;
                }
                .wl-section-title::after { content: ""; flex: 1; height: 1px; background: ${LIGHT_GREEN}; }
                
                .wl-text { font-size: 14.5px; line-height: 1.6; color: ${GRAY_TEXT}; margin-bottom: 15px; }
                
                .wl-list { list-style: none; padding-left: 5px; }
                .wl-list-item { 
                    font-size: 14.5px; margin-bottom: 8px; display: flex; align-items: center; gap: 10px; 
                    color: ${DARK_TEXT}; font-weight: 500;
                }
                .wl-list-item::before { content: "✓"; color: ${PRIMARY_GREEN}; font-weight: 900; }

                .wl-belief-box {
                    background: ${LIGHT_GREEN}55; border-left: 4px solid ${PRIMARY_GREEN};
                    padding: 20px; border-radius: 0 8px 8px 0; margin: 30px 0;
                }
                .wl-belief-title { font-weight: 800; color: ${PRIMARY_GREEN}; margin-bottom: 8px; }
                .wl-belief-text { font-weight: 600; color: ${DARK_TEXT}; font-size: 15px; }

                .wl-footer { margin-top: 50px; }
                .wl-sign-off { margin-bottom: 30px; line-height: 1.6; font-weight: 600; }
                .wl-signature { font-size: 18px; font-weight: 800; color: ${PRIMARY_GREEN}; }
                .wl-team { font-size: 14px; font-weight: 600; color: ${GRAY_TEXT}; }

                .wl-overlap-spot { position: relative; display: inline-block; margin-top: 10px; padding-top: 30px; }
                .wl-sig-img { position: absolute; top: -65px; left: 30px; width: 140px; z-index: 12; transform: rotate(-5deg); }
                .wl-stamp-img { position: absolute; top: -55px; left: 40px; width: 120px; opacity: 0.85; z-index: 11; }

                .wl-quote {
                    text-align: center; margin-top: 60px; padding: 20px;
                    border-top: 1px dashed ${LIGHT_GREEN}; border-bottom: 1px dashed ${LIGHT_GREEN};
                    font-style: italic; font-weight: 800; color: ${BLUE_TEXT}; font-size: 20px;
                }

                /* ── PRINT ── */
                @media print {
                    @page { size: A4; margin: 0; }
                    .no-print { display: none !important; }
                    .wl-container { background: #fff !important; padding: 0 !important; }
                    .wl-paper-wrap { margin: 0 !important; max-width: 100% !important; transform: none !important; }
                    .wl-paper { box-shadow: none !important; border: none !important; min-height: 100vh; padding: 40px 50px; }
                    .wl-side-strip { display: block !important; }
                }

                /* ── RESPONSIVE ── */
                @media (max-width: 850px) {
                    .wl-paper-wrap { 
                        margin: 10px auto; 
                        width: 95%;
                        overflow-x: auto;
                    }
                    .wl-paper { 
                        padding: 40px 25px; 
                        min-height: auto;
                        width: 100%;
                        min-width: 320px;
                    }
                    .wl-header { flex-direction: column; gap: 15px; }
                    .wl-brand-box h1 { font-size: 26px; }
                    .wl-quote { font-size: 16px; margin-top: 40px; }
                }

                @media (max-width: 480px) {
                    .wl-bar { padding: 10px; }
                    .wl-back span, .wl-print span { display: none; }
                    .wl-back::after { content: "Back"; }
                    .wl-print::after { content: "Print"; }
                    .wl-lang-btn { height: 35px; padding: 0 8px; font-size: 11px; }
                }
            `}</style>

            <div className="wl-container">

                {/* ACTION BAR */}
                <div className="wl-bar no-print">
                    <div className="wl-bar-left">
                        <button className="wl-back" onClick={() => navigate(-1)}>
                            <span>←</span>
                        </button>
                        <button className="wl-lang-btn" onClick={() => setLang(lang === 'en' ? 'te' : 'en')}>
                            🌐 {lang === 'en' ? "Telugu" : "English"}
                        </button>
                    </div>
                    <button className="wl-print" onClick={handlePrint}>
                        <span>🖨</span>
                    </button>
                </div>

                {/* LOADING */}
                {loading && (
                    <div className="wl-status-box">
                        <div className="wl-spinner" />
                        <p>Loading Welcome Letter...</p>
                    </div>
                )}

                {/* ERROR */}
                {!loading && err && (
                    <div className="wl-status-box">
                        <p style={{color:'red'}}>{err}</p>
                        <button className="wl-back" onClick={fetchLetter}>Retry</button>
                    </div>
                )}

                {/* LETTER */}
                {!loading && !err && data && (
                    <div ref={printRef} className="wl-paper-wrap">
                        <div className="wl-paper">
                            <div className="wl-side-strip" />
                            <div className="wl-corner-top" />
                            
                            {/* HEADER */}
                            <header className="wl-header">
                                <div className="wl-brand-box">
                                    <h1>{t.title}</h1>
                                    <p>{t.welcome}</p>
                                </div>
                                <div className="wl-date-box">
                                    {safe(data.dateOfJoining, new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }))}
                                </div>
                            </header>

                            {/* CONTENT */}
                            <main className="wl-content">
                                <div className="wl-salutation">{t.dear} {safe(data.name)} {lang === 'te' ? 'గారికి,' : ','}</div>
                                <div className="wl-intro">{t.congrats}</div>
                                
                                <div className="wl-member-id">
                                    {t.memberId}: <span style={{color: PRIMARY_GREEN}}>{safe(data.userName)}</span>
                                </div>

                                <div className="wl-text" style={{marginBottom: '30px'}}>{t.decisionText}</div>

                                <section className="wl-section">
                                    <h2 className="wl-section-title">{t.aboutTitle}</h2>
                                    <p className="wl-text">{t.aboutDesc}</p>
                                    <p className="wl-text" style={{fontWeight: 700, color: DARK_TEXT}}>{t.learnTitle}</p>
                                    <ul className="wl-list">
                                        {t.learnItems.map((item, idx) => (
                                            <li key={idx} className="wl-list-item">{item}</li>
                                        ))}
                                    </ul>
                                </section>

                                <section className="wl-section">
                                    <h2 className="wl-section-title">📘 {t.trainingTitle}</h2>
                                    <ul className="wl-list">
                                        {t.trainingItems.map((item, idx) => (
                                            <li key={idx} className="wl-list-item">{item}</li>
                                        ))}
                                    </ul>
                                </section>

                                <section className="wl-section">
                                    <h2 className="wl-section-title">🚀 {t.successTitle}</h2>
                                    <p className="wl-text">{t.successGoal}</p>
                                    <ul className="wl-list">
                                        {t.successItems.map((item, idx) => (
                                            <li key={idx} className="wl-list-item">{item}</li>
                                        ))}
                                    </ul>
                                </section>

                                <div className="wl-belief-box">
                                    <div className="wl-belief-title">🌟 {t.beliefTitle}</div>
                                    <div className="wl-belief-text">{t.beliefDesc}</div>
                                </div>

                                <div className="wl-footer">
                                    <div className="wl-sign-off">
                                        {t.supportLine}<br/>
                                        {t.successWish}
                                    </div>
                                    <div className="wl-overlap-spot">
                                        <div className="wl-signature">{t.thankYou}</div>
                                        <div className="wl-team">{t.team}</div>

                                        <img src={signatureImg} alt="Signature" className="wl-sig-img" />
                                        <img src={stampImg} alt="Stamp" className="wl-stamp-img" />
                                    </div>
                                </div>

                                <div className="wl-quote">{t.quote}</div>
                            </main>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}